module.exports = __webpack_public_path__ + "img/ids-logs-observed-events.1bae7eb5.png";